import { IEnvConfig } from '@elyx-code/project-logic-tree';

// Webpack replaces process.env.APP_ENV at build time based on our script flag
const ENV = process.env.APP_ENV as 'dev' | 'staging' | 'prod';

const environments: {
	[key in 'dev' | 'staging' | 'prod']: IEnvConfig;
} = {
	dev: {
		stripe_publishable_key: 'pk_test_rYj0t30AfihMVtTZQA2HjjuT',
		stripe_pricing_table_id: 'prctbl_1TREcAFUJjMj5cqLEALlJZfX',
		stripe_personal_sub_mngmt_url:
			'https://billing.stripe.com/p/login/test_5kQ5kDftobJmdMvczqgbm00',
		stripe_org_sub_mngmt_url: '',
		API_BASE_URL: 'https://api.dev.elyx.tech',
		WS_URL: 'wss://ws.dev.elyx.tech', // For local development, you might want to use the same URL for both HTTP and WS, or adjust as needed
		amplifyConfig: {
			aws_project_region: 'eu-central-1',
			aws_cognito_region: 'eu-central-1',
			aws_user_pools_id: 'eu-central-1_BpCJZs139', // Your Dev User Pool ID
			aws_user_pools_web_client_id: '142cc9h5brsmt65p07i17r3b2k', // Your Dev Client ID
			aws_cognito_username_attributes: ['EMAIL'],
			aws_cognito_signup_attributes: ['EMAIL'],
			aws_cognito_password_protection_settings: {
				passwordPolicyMinLength: 8,
				passwordPolicyCharacters: [
					'REQUIRES_LOWERCASE',
					'REQUIRES_UPPERCASE',
					'REQUIRES_NUMBERS',
					'REQUIRES_SYMBOLS',
				],
			},
			aws_cognito_verification_mechanisms: ['EMAIL'],
		},
		HELP_ARTICLES_URL:
			'https://elyx-dev-help-articles.s3.eu-central-1.amazonaws.com',
		PUBLIC_EXTERNAL_INTEGRATIONS_URL:
			'https://elyx-dev-public-external-integrations.s3.eu-central-1.amazonaws.com',
		EXTERNAL_INTEGRATIONS_URL: 'https://integrations.dev.elyx.tech',
		EXTERNAL_INTEGRATIONS_CONNECT_URL: 'https://connect.dev.elyx.tech',
		EXTERNAL_INTEGRATIONS_LOGOS_URL:
			'https://app.nango.dev/images/template-logos',
		HTTP_CLIENT_URL: 'https://df2h57ytbvezp.cloudfront.net',
		EDITOR_RUNTIME_IP_ADDRESS: '35.157.54.29',
		GOOGLE_PICKER_APP_ID: '5729685821',
		GOOGLE_PICKER_API_KEY: 'AIzaSyCifEH3gMsOsOCaHMeQbGafHKlQSPUEmEA',
	},
	staging: {
		stripe_publishable_key: 'pk_test_rYj0t30AfihMVtTZQA2HjjuT',
		stripe_pricing_table_id: 'prctbl_1TREcAFUJjMj5cqLEALlJZfX',
		stripe_personal_sub_mngmt_url:
			'https://billing.stripe.com/p/login/test_5kQ5kDftobJmdMvczqgbm00',
		stripe_org_sub_mngmt_url: '',
		API_BASE_URL: 'https://api.staging.elyx.tech', // Future staging API
		WS_URL: 'wss://ws.staging.elyx.tech',
		amplifyConfig: {
			aws_project_region: 'eu-central-1',
			aws_cognito_region: 'eu-central-1',
			aws_user_pools_id: 'eu-central-1_Hqy56jrad', // Your Staging User Pool ID
			aws_user_pools_web_client_id: '3p75u41s5b32okj31hr2lvqcer', // Your Staging Client ID
			aws_cognito_username_attributes: ['EMAIL'],
			aws_cognito_signup_attributes: ['EMAIL'],
			aws_cognito_password_protection_settings: {
				passwordPolicyMinLength: 8,
				passwordPolicyCharacters: [
					'REQUIRES_LOWERCASE',
					'REQUIRES_UPPERCASE',
					'REQUIRES_NUMBERS',
					'REQUIRES_SYMBOLS',
				],
			},
			aws_cognito_verification_mechanisms: ['EMAIL'],
		},
		HELP_ARTICLES_URL:
			'https://elyx-staging-help-articles.s3.eu-central-1.amazonaws.com',
		// External integrations for staging share the 'dev' environments resources
		PUBLIC_EXTERNAL_INTEGRATIONS_URL:
			'https://elyx-dev-public-external-integrations.s3.eu-central-1.amazonaws.com',
		EXTERNAL_INTEGRATIONS_URL: 'https://integrations.dev.elyx.tech',
		EXTERNAL_INTEGRATIONS_CONNECT_URL: 'https://connect.dev.elyx.tech',
		EXTERNAL_INTEGRATIONS_LOGOS_URL:
			'https://app.nango.dev/images/template-logos',
		HTTP_CLIENT_URL: 'https://d2i41032bsu0o2.cloudfront.net',
		EDITOR_RUNTIME_IP_ADDRESS: '63.182.186.122',
		GOOGLE_PICKER_APP_ID: '5729685821',
		GOOGLE_PICKER_API_KEY: 'AIzaSyCifEH3gMsOsOCaHMeQbGafHKlQSPUEmEA',
	},
	prod: {
		stripe_publishable_key: 'pk_live_HrFGNCp9YrKECgyAh5f4JMZO',
		stripe_pricing_table_id: 'prctbl_1TRDRIFUJjMj5cqLss0ervUw',
		stripe_personal_sub_mngmt_url:
			'https://billing.stripe.com/p/login/5kQ5kDftobJmdMvczqgbm00',
		stripe_org_sub_mngmt_url: '',
		API_BASE_URL: 'https://api.elyx.tech',
		WS_URL: 'wss://ws.elyx.tech',
		amplifyConfig: {
			aws_project_region: 'eu-central-1',
			aws_cognito_region: 'eu-central-1',
			aws_user_pools_id: 'eu-central-1_MzPRdm914',
			aws_user_pools_web_client_id: '4hejvd5qnn2dhit4trd9kdcb2u',
			aws_cognito_username_attributes: ['EMAIL'],
			aws_cognito_signup_attributes: ['EMAIL'],
			aws_cognito_password_protection_settings: {
				passwordPolicyMinLength: 8,
				passwordPolicyCharacters: [
					'REQUIRES_LOWERCASE',
					'REQUIRES_UPPERCASE',
					'REQUIRES_NUMBERS',
					'REQUIRES_SYMBOLS',
				],
			},
			aws_cognito_verification_mechanisms: ['EMAIL'],
		},
		HELP_ARTICLES_URL:
			'https://elyx-prod-help-articles.s3.eu-central-1.amazonaws.com',
		PUBLIC_EXTERNAL_INTEGRATIONS_URL:
			'https://elyx-prod-public-external-integrations.s3.eu-central-1.amazonaws.com',
		EXTERNAL_INTEGRATIONS_URL: 'https://integrations.elyx.tech',
		EXTERNAL_INTEGRATIONS_CONNECT_URL: 'https://connect.elyx.tech',
		EXTERNAL_INTEGRATIONS_LOGOS_URL:
			'https://app.nango.dev/images/template-logos',
		HTTP_CLIENT_URL: 'https://d3meuwyksvik3l.cloudfront.net',
		EDITOR_RUNTIME_IP_ADDRESS: '3.76.93.206',
		GOOGLE_PICKER_APP_ID: '5729685821',
		GOOGLE_PICKER_API_KEY: 'AIzaSyCifEH3gMsOsOCaHMeQbGafHKlQSPUEmEA',
	},
};

// Fallback to dev if something goes weird
export const envConfig = environments[ENV] || environments.dev;
